
import { DossierConfigService } from "@/services/dossier-config-service";
import Vue from "vue";
import {IBreadCrumb, ISelectItem} from "winfakt-vue-components";
import AppCountryCodeAutocomplete from "@/components/CountryCodeAutocomplete.vue";
import { UserConfigService } from "@/services";
import AppSellPriceCategorySelect from "@/components/SellPriceCategorySelect.vue";
import {getExtraFieldKeyNames} from "@/utils/models/extra-fields";

export default Vue.extend({
	data(){
		return {
			config: DossierConfigService.getContactsConfig(),
			userConfig: UserConfigService.getGeneralSettings(),
		};
	},
	computed: {
		path():IBreadCrumb[] {
			return [
				{
					to: "/settings", value: this.$ct("general")
				},
				{
					value: this.$ct("contacts")
				}
			] as IBreadCrumb[];
		},
		extraFieldNames(): ISelectItem<string>[] {
			let t = getExtraFieldKeyNames("Bool");
			let r = t.map(d => {
				return {
					text: d,
					value: d
				} as ISelectItem<string>;
			});
			r.unshift({
				text: this.$ct("common.empty").toString(),
				value: ""
			});
			return r;
		},
	},
	methods: {
		async save(){
			await DossierConfigService.saveContactsConfig(this.config);
			await UserConfigService.setGeneralSettings(this.userConfig);
			this.$router.back();
		}
	},
	components: {
		AppCountryCodeAutocomplete,
		AppSellPriceCategorySelect
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
